import { selectorFamily } from "recoil";
import { layerDefsAtomFamily } from "../layerDefsAtoms";

export const layerDefOpacitySelector = selectorFamily({
  key: "layer-opacity-selector",
  get:
    (layerID) =>
    ({ get }) => {
      const { layer } = get(layerDefsAtomFamily(layerID));
      if (layer.type !== "fill") {
        return;
      }
      return layer?.paint["fill-opacity"];
    },
  set:
    (layerID) =>
    ({ set }, newOpacity) => {
      set(layerDefsAtomFamily(layerID), (oldLayer) => {
        const opacityLimits = oldLayer.opacityLimits
        return {
          ...oldLayer,
          layer: applyLayerOpacity(opacityLimits, oldLayer.layer, newOpacity),
          overLayers: oldLayer.overLayers?.map((ol) => {
            return applyLayerOpacity(opacityLimits, ol, newOpacity)
          })
        };
      });
    },
});

const applyLayerOpacity = (opacityLimits, layer, newOpacity) => {
  if (!ignoreOpacityChanges(opacityLimits, layer, newOpacity)) {
    return {
      ...layer,
      paint: {
        ...layer.paint,
        "fill-opacity": newOpacity,
      },
    }
  }

  return layer
}

const ignoreOpacityChanges = (opacityLimits, layer, newOpacity) => {
  if (layer.type !== 'fill') {
    return true
  }

  if (!opacityLimits || !opacityLimits[layer.id]) {
    return false
  }

  const [min, max] = opacityLimits[layer.id]
  return newOpacity < min || newOpacity > max
}